import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
    state: () => ({
        data: null
    }),

    getters: {
        initials(state) {
            if (!state.data || !state.data.name) {
                return '';
            }

            let name = state.data.name;
            const words = name.split(' ');
            const initials = words.map((word) => word.charAt(0)).join('');
            const initialsNumber = initials.length;

            if (initialsNumber === 1) {
                return initials;
            }

            if ([2, 3].includes(initialsNumber)) {
                return initials.substring(0, 2);
            }

            return initials.charAt(0) + initials.charAt(2);
        },

        isMaster(state) {
            return state.data.agency.isMaster;
        }
    },

    persist: true
});
